<script>
  import { createEventDispatcher } from 'svelte';
  import Modal from '@components/Modal.svelte';
  import Input from '@components/Input.svelte';
  import Notification from '@utils/notification';
  import { getGroupStore } from '@stores/group';
  let groupStore = getGroupStore('groupStore');
  let sectionsStore = getGroupStore('sectionsStore');
  import SectionAjax from '@ajax/section';

  const dispatch = createEventDispatcher();

  export let showModal = false;
  export let mobile;

  let group = groupStore;
  let adding = false;
  let name = '';

  var close = function (section) {
    dispatch('close', { section: section });

    showModal = false;
    adding = false;
    name = '';
  };

  let submitOnEnter = function (e) {
    if (e.detail.which == 13) {
      addSection();
    }
  };

  let addSection = async function () {
    adding = true;

    try {
      let resp = await SectionAjax.create(group, {
        name: name,
      });
      sectionsStore.add(resp);
      return close(resp);
    } catch (err) {
      if (err && err.full_errors && err.full_errors.length > 0) {
        Notification.send({
          text: err.full_errors[0],
        });
      }
    }

    close();
  };
</script>

<style style="text/scss" lang="scss">
  .ui-header {
    font-weight: 500;
    font-size: 20px;
    text-align: center;
  }

  .ui-cancel {
    font-weight: 500;
    color: black;
  }

  .form-input-group {
    margin-bottom: 16px;
  }

  .add-section-link {
    font-size: 15px;
    opacity: 0.5;
    font-weight: 500;
    line-height: 15px;
    color: #000;

    &:hover {
      opacity: 1;
    }
  }

  label {
    font-size: 13px;
    line-height: 15px;
    opacity: 0.5;
    margin-bottom: 12px;
    font-weight: normal;
  }

  .ui-actions {
    margin-top: 40px;
    max-width: 275px;
    margin-left: auto;
    margin-right: auto;

    .add-section-btn {
      height: 48px;
      color: white;
      font-weight: 500;
      font-size: 14px;
      border: none;
      border-radius: 15px;
      background: #a893f9;
      width: 275px;

      &:hover {
        background: #7054dc;
      }
    }

    .cancel-btn {
      width: 100%;
      color: #000;
      font-size: 15px;
      margin-top: 12px;
      font-weight: 500;
      border: none;
      background: transparent;
    }
  }
</style>

<Modal
  mobile={mobile}
  on:close={close}
  show={showModal}
  showCloseButton={false}
  fadeInDuration={200}
  style="border-radius: 16px; width: 490px">
  <div slot="content">
    <div class="ui-header">Add Section</div>

    <div
      style="margin-top: 50px; width: 275px; margin-left: auto; margin-right:
      auto;">
      <Input
        focus={true}
        bind:value={name}
        label="Section Name"
        labelStyle="font-size: 15px"
        inputStyle="font-size: 17px; font-weight: normal"
        placeholder="E.g. Doctors"
        on:keyup={submitOnEnter} />
    </div>

    <div class="ui-actions">
      <button class="add-section-btn" on:click|preventDefault={addSection}>
        {#if adding}
          <div>
            <i class="fa fa-spin fa-spinner" />
            <span style="margin-left: 10px;">Adding section</span>
          </div>
        {:else}Add Section{/if}
      </button>
      <button class="cancel-btn" on:click|preventDefault={() => close()}>Cancel</button>
    </div>
  </div>
</Modal>
